<template>
  <AppHeader>Low Balance Customers</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">

    <div class="responsive-table">
      <table>
        <thead>
          <tr>
            <th>No.</th>
            <th>ID</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Wallet</th>
            <th>Needs</th>
            <th>Group</th>
            <th>Address</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="(customer, index) in customers" :key="customer.id">
            <td>{{ index + 1 }}</td>
            <td>#{{ customer.id }}</td>
            <td><router-link :to="{name: 'ViewCustomer', params: {id: customer.id}}"><b>{{ customer.name }}</b></router-link></td>
            <td align="center"><a @click="initiateCall(customer.phone)" class="px-2"><i class="ion-md-call"></i></a></td>
            <td>{{ toInr(customer.wallet_balance) }}</td>
            <td>{{ toInr(customer.amount_needed) }}</td>
            <td><small>{{ customer.group_name }}</small></td>
            <td><small>{{ customer.address }}</small></td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'CustomersLowBalance',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      customers: [],
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'customers/low-balance', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.customers = resp.data.customers;
        }
      });
    },
  },

  created() {
    if (!this.$store.state.user.id) this.$router.push('/dash');
    else this.getData();
  }
}
</script>
